module.exports = __webpack_public_path__ + "static/media/uztv-logo.e8204805.svg";